import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillFacebook } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Qui <span className="brown"> suis-je ? </span>
            </h1>
            <p className="home-about-body">
              Je suis passionné par le développement de sites web et
              d'applications logicielles, où
              <br />
              <br />
              J'excelle notamment dans l'utilisation des langages
              <i>
                <b className="brown"> C#, PHP, JavaScript, VBA et Python</b>
              </i>
              <br />
              <br />
              Fort d'une expérience solide en tant que développeur,
              <br />
              <br />
              J'ai acquis des compétences éprouvées dans la{" "}
              <i>
                <b className="brown">conception</b>
              </i>{" "}
              et le{" "}
              <i>
                <b className="brown">développement</b>
              </i>{" "}
              de sites et d'applications web, ainsi que dans la{" "}
              <i>
                <b className="brown">création de logiciels</b>
              </i>{" "}
              de bureau
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt className="avatar">
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Trouvez-moi sur</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Laurent3898/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/laurent-junot-rakotondrabe/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://web.facebook.com/Laurent.Junot.Rakotondrabe/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
